(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('ListFilterStateFactory', ListFilterStateFactory);

    function ListFilterStateFactory(lodash) {
        const state = {};

        return {
            create: function(listFilterMem, identifier) {
                if (identifier === null) {
                    lodash.set(state, 'default', listFilterMem);
                } else {
                    lodash.set(state, identifier, listFilterMem);
                }
            },
            get: function(identifier) {
                if (lodash.isEmpty(identifier)) {
                    return lodash.get(state, 'default', null);
                }
                return lodash.get(state, identifier, null);
            },
            destroy: function(identifier) {
                if (lodash.has(state, identifier)) {
                    state[identifier].destroy();
                    delete state[identifier];
                }
            },
            getAll: function() {
                return state;
            }
        }
    }
})();